<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content class="mat-typography">
  <p>{{ message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <!-- <button mat-button mat-dialog-close>Cancel</button> -->
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>ok</button>
</mat-dialog-actions>
